
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="800px"
      transition="dialog-transition"
    >
      <base-card with_divider>
        <template slot="title">
          <span class="text-capitalize">
            {{ is_edit && $tc('tasks.subtasks.edit') || is_new && $tc('tasks.subtasks.new')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="subtaskForm">
            <v-text-field 
              :placeholder="$t('tasks.subtasks.name_form_label')"
              solo flat class="black--text" style="font-weight: 900; font-size: large !important;"
              v-model="local_subtask.name" dense
              :rules="required"
            ></v-text-field>

          </v-form>
        </template>

        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancel" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="save" text>{{ $t('save') }}</v-btn>
        </template>
      </base-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'DialogCreateSubtask',
  mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  props: {
    subtask: {
      type: Object,
    },
    position: {
      type: [String, Number]
    },
    is_new: {
      type: Boolean,
      default: false,
    },
    is_edit: {
      type: Boolean,
      default: false,
    },
    task_id: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: true,
      ready: false,

      loading: false,

      local_subtask: {},

      default_subtask: {
        ref: null,
        name: null,
        due_at: null,
        done_at: null,
        position: null,
      },
    }
  },
  methods: {
    setupLocalTask() {
      this.ready = false
      if (this.is_edit && this.subtask){
        this.local_subtask = {
          ...this.subtask,
          position: this.subtask.idx + 1
        }
      } else {
        this.local_subtask = {
          ...this.default_subtask,
          position: this.position,
        }
      }
      this.ready = true
    },
    cancel(){
      this.$emit('cancel')
    },
    save(){
      if (this.$refs.subtaskForm.validate()){
        this.$emit('done', {...this.local_subtask, position: this.position})
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv == false){
        this.cancel()
      }
    }
  },
  mounted () {
    this.local_subtask = {
      ...this.subtask,
      // ...this.subtask.json_attributes,
    };
  },
}
</script>

<style scoped>

</style>